/**
 * Simulates a mouse event based on a touch event. This enables GridStack module resizing on touch devices.
 * @param event: TouchEvent
 */
export function translateTouchEventToMouseEvent(event) {
    const touch = event.changedTouches[0];
    const simulatedEvent = document.createEvent('MouseEvent');
    const touchEventToMouseEventMap = {
        touchstart: 'mousedown',
        touchmove: 'mousemove',
        touchend: 'mouseup',
    };
    simulatedEvent.initMouseEvent(touchEventToMouseEventMap[event.type], true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
    touch.target.dispatchEvent(simulatedEvent);
    event.preventDefault();
}
/**
 * Determines whether the first element entirely contains the second element on the vertical axis (its top is above the top of the
 * second element, and its bottom is below the bottom of the second element)
 * @param container
 * @param contained
 */
export const verticallyContains = (container, contained) => {
    const containerRect = container.getBoundingClientRect();
    const containedRect = contained.getBoundingClientRect();
    return containedRect.top >= containerRect.top && containedRect.bottom <= containerRect.bottom;
};
